'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Front = _interopRequireDefault(require("Layouts/Front"));
var _LoginModal = _interopRequireDefault(require("Modals/LoginModal"));
var _RecrutementIcon = _interopRequireDefault(require("Icons/RecrutementIcon"));
var _PreparationEmploiIcon = _interopRequireDefault(require("Icons/PreparationEmploiIcon"));
var _FormationIcon = _interopRequireDefault(require("Icons/FormationIcon"));
var _MaintienEmploiIcon = _interopRequireDefault(require("Icons/MaintienEmploiIcon"));
var _BlockLastTestimonies = _interopRequireDefault(require("Components/Block/BlockLastTestimonies"));
var _Link = _interopRequireDefault(require("Pure/Link"));
var _Image = _interopRequireDefault(require("Pure/Image"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
let app = window.app;
class InfoCompanyPage extends _react.Component {
  state = {
    login_modal: false
  };
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    component.fetchPartner();
  }
  openLoginModal = e => {
    const component = this,
      props = this.props,
      state = this.state;
    e.persist();
    component.setState({
      login_modal_trigger: e.target,
      login_modal: true
    });
  };
  closeLoginModal = e => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      login_modal_trigger: undefined,
      login_modal: false
    });
  };
  handleLogin = () => {
    const component = this,
      props = this.props,
      state = this.state;

    // Update user permissions now that user is connected
    app.emit({
      event: 'sessionNeedsRefresh',
      source: 'loginModal'
    });
  };
  fetchPartner = () => {
    const component = this,
      props = this.props,
      state = this.state;
    qwest.post('/partner/get-all').then(function (xhr, response) {
      component.setState({
        loading: false,
        partners: response.partners
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || error);
      component.setState({
        loading: false,
        info: undefined,
        error: response?.error,
        warning: response?.warning
      });
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    let partners = (state.partners || []).map(function (partner) {
      let output = /*#__PURE__*/_react.default.createElement("div", {
        className: "c-partner__item",
        key: partner.id
      }, partner?.logo?.[0]?.url ? /*#__PURE__*/_react.default.createElement(_Image.default, {
        src: partner?.logo?.[0]?.url,
        alt: partner?.name
      }) : /*#__PURE__*/_react.default.createElement("p", {
        className: "u-flex u-text-center u-center u-full-width"
      }, partner?.name));
      return output;
    });
    let output = /*#__PURE__*/_react.default.createElement(_Front.default, _extends({
      page_title: "Vous \xEAtes une entreprise ? | AspieJob"
    }, props), /*#__PURE__*/_react.default.createElement("div", {
      className: "o-content u-margin-top-10"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "c-candidat-project"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "c-candidat-project__column c-candidat-project__column--txt"
    }, /*#__PURE__*/_react.default.createElement("h1", {
      className: "c-title"
    }, "Valorisez votre impact social en recrutant des talents Asperger"), /*#__PURE__*/_react.default.createElement("p", null, "Acc\xE9dez \xE0 nos services cl\xE9s en main et \xE0 notre", /*#__PURE__*/_react.default.createElement("br", null), "s\xE9lection de candidats"), /*#__PURE__*/_react.default.createElement(_Link.default, {
      className: "c-btn c-btn--orange u-margin-top-40",
      href: "/inscription-entreprise"
    }, "Inscrivez-vous gratuitement")), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-candidat-project__column c-candidat-project__column--img"
    }, /*#__PURE__*/_react.default.createElement(_Image.default, {
      src: "/images/aspiejob-employeurs.svg",
      className: "c-candidat-project_img"
    }))), /*#__PURE__*/_react.default.createElement("h2", {
      className: "c-title c-title--medium u-text-center u-margin-top-40"
    }, "Ce que nous vous proposons"), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-parcours-grid c-parcours-grid--4"
    }, /*#__PURE__*/_react.default.createElement(_Link.default, {
      href: "/recrutement-et-integration",
      className: "c-parcours-grid-item c-parcours-grid-item--green"
    }, /*#__PURE__*/_react.default.createElement(_RecrutementIcon.default, {
      className: "c-parcours-grid-item__icon"
    }), /*#__PURE__*/_react.default.createElement("p", {
      className: "c-parcours-grid-item__txt"
    }, "Recrutement et int\xE9gration de candidats"), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-parcours-grid-item__link"
    }, "En savoir plus")), /*#__PURE__*/_react.default.createElement(_Link.default, {
      href: "/preparation-a-l-emploi",
      className: "c-parcours-grid-item c-parcours-grid-item--orange"
    }, /*#__PURE__*/_react.default.createElement(_PreparationEmploiIcon.default, {
      className: "c-parcours-grid-item__icon"
    }), /*#__PURE__*/_react.default.createElement("p", {
      className: "c-parcours-grid-item__txt"
    }, "Pr\xE9paration Op\xE9rationnelle \xE0 l\u2019Emploi"), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-parcours-grid-item__link"
    }, "En savoir plus")), /*#__PURE__*/_react.default.createElement(_Link.default, {
      href: "/formation-sensibilisation",
      className: "c-parcours-grid-item c-parcours-grid-item--blue"
    }, /*#__PURE__*/_react.default.createElement(_FormationIcon.default, {
      className: "c-parcours-grid-item__icon"
    }), /*#__PURE__*/_react.default.createElement("p", {
      className: "c-parcours-grid-item__txt"
    }, "Formations & Sensibilisation"), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-parcours-grid-item__link"
    }, "En savoir plus")), /*#__PURE__*/_react.default.createElement(_Link.default, {
      href: "/maintien-emploi",
      className: "c-parcours-grid-item c-parcours-grid-item--pink"
    }, /*#__PURE__*/_react.default.createElement(_MaintienEmploiIcon.default, {
      className: "c-parcours-grid-item__icon"
    }), /*#__PURE__*/_react.default.createElement("p", {
      className: "c-parcours-grid-item__txt"
    }, "Maintien en emploi"), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-parcours-grid-item__link"
    }, "En savoir plus"))), /*#__PURE__*/_react.default.createElement("h2", {
      className: "c-title c-title--medium u-text-center u-margin-top-60"
    }, "Acc\xE9dez \xE0 nos profils"), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-profil-list"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "c-profil-list__item"
    }, /*#__PURE__*/_react.default.createElement("h3", {
      className: "c-profil-list__item__title c-profil-list__item__title--blue"
    }, "Toutes formes de contrats"), /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", {
      className: "c-circle-decoration c-circle-decoration--blue"
    }, "CDD"), /*#__PURE__*/_react.default.createElement("li", {
      className: "c-circle-decoration c-circle-decoration--blue"
    }, "CDI"), /*#__PURE__*/_react.default.createElement("li", {
      className: "c-circle-decoration c-circle-decoration--blue"
    }, "Freelance"), /*#__PURE__*/_react.default.createElement("li", {
      className: "c-circle-decoration c-circle-decoration--blue"
    }, "Alternance"))), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-profil-list__item"
    }, /*#__PURE__*/_react.default.createElement("h3", {
      className: "c-profil-list__item__title c-profil-list__item__title--pink"
    }, "Tous domaines"), /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", {
      className: "c-circle-decoration c-circle-decoration--pink"
    }, "Informatique"), /*#__PURE__*/_react.default.createElement("li", {
      className: "c-circle-decoration c-circle-decoration--pink"
    }, "Ing\xE9nierie"), /*#__PURE__*/_react.default.createElement("li", {
      className: "c-circle-decoration c-circle-decoration--pink"
    }, "D\xE9veloppement"), /*#__PURE__*/_react.default.createElement("li", {
      className: "c-circle-decoration c-circle-decoration--pink"
    }, "Langues"), /*#__PURE__*/_react.default.createElement("li", {
      className: "c-circle-decoration c-circle-decoration--pink"
    }, "Communication"), /*#__PURE__*/_react.default.createElement("li", {
      className: "c-circle-decoration c-circle-decoration--pink"
    }, "Recherche"), /*#__PURE__*/_react.default.createElement("li", {
      className: "c-circle-decoration c-circle-decoration--pink"
    }, "Jeux vid\xE9os"), /*#__PURE__*/_react.default.createElement("li", {
      className: "c-circle-decoration c-circle-decoration--pink"
    }, "Marketing"), /*#__PURE__*/_react.default.createElement("li", {
      className: "c-circle-decoration c-circle-decoration--pink"
    }, "..."))), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-profil-list__item"
    }, /*#__PURE__*/_react.default.createElement("h3", {
      className: "c-profil-list__item__title c-profil-list__item__title--orange"
    }, "Tous niveaux de qualification"), /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", {
      className: "c-circle-decoration c-circle-decoration--orange"
    }, "CAP"), /*#__PURE__*/_react.default.createElement("li", {
      className: "c-circle-decoration c-circle-decoration--orange"
    }, "Doctorat"), /*#__PURE__*/_react.default.createElement("li", {
      className: "c-circle-decoration c-circle-decoration--orange"
    }, "Master"), /*#__PURE__*/_react.default.createElement("li", {
      className: "c-circle-decoration c-circle-decoration--orange"
    }, "Licence"), /*#__PURE__*/_react.default.createElement("li", {
      className: "c-circle-decoration c-circle-decoration--orange"
    }, "Bac professionnel"), /*#__PURE__*/_react.default.createElement("li", {
      className: "c-circle-decoration c-circle-decoration--orange"
    }, "..."))), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-profil-list__item"
    }, /*#__PURE__*/_react.default.createElement("h3", {
      className: "c-profil-list__item__title c-profil-list__item__title--green"
    }, "Tous niveaux d\u2019exp\xE9rience"), /*#__PURE__*/_react.default.createElement(_Image.default, {
      src: "/images/niveauxexperience.svg"
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-profil"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "c-profil__column"
    }, /*#__PURE__*/_react.default.createElement(_Image.default, {
      src: "/images/vivierdeprofils.svg"
    }), /*#__PURE__*/_react.default.createElement("h3", null, "Un vivier de profils"), /*#__PURE__*/_react.default.createElement("p", null, "Nous sour\xE7ons nos candidats", /*#__PURE__*/_react.default.createElement("br", null), "gr\xE2ce \xE0 notre r\xE9seau exclusif de", /*#__PURE__*/_react.default.createElement("br", null), "partenaires et institutions.")), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-profil__column"
    }, /*#__PURE__*/_react.default.createElement(_Image.default, {
      src: "/images/cartes-candidats.svg"
    }), /*#__PURE__*/_react.default.createElement("h3", null, "Des candidats pr\xE9-s\xE9lectionn\xE9s"), /*#__PURE__*/_react.default.createElement("p", null, "Notre \xE9quipe d\u2019experts rencontre et", /*#__PURE__*/_react.default.createElement("br", null), "accompagne chaque candidat qui vous est", /*#__PURE__*/_react.default.createElement("br", null), "pr\xE9sent\xE9."))), /*#__PURE__*/_react.default.createElement("div", {
      className: "u-flex u-margin-top-40 u-center u-full-width"
    }, /*#__PURE__*/_react.default.createElement(_Link.default, {
      className: "c-btn c-btn--green",
      href: "/inscription-entreprise"
    }, "Trouvez votre futur collaborateur")), /*#__PURE__*/_react.default.createElement("h2", {
      className: "c-title c-title--medium u-text-center u-margin-top-40  u-margin-bottom-0"
    }, "Comment \xE7a marche ?"), /*#__PURE__*/_react.default.createElement("p", {
      className: "u-text-center u-margin-top-0"
    }, "Vous \xEAtes accompagn\xE9s du recrutement, \xE0 l\u2019int\xE9gration", /*#__PURE__*/_react.default.createElement("br", null), "du candidat et plus encore."), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-list-etape"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "c-list-etape__item"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "c-list-etape__item-number c-list-etape__item-number--green"
    }, "1."), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-list-etape__item-txt"
    }, "Vous d\xE9posez votre offre d\u2019emploi ou votre projet")), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-list-etape__item"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "c-list-etape__item-number c-list-etape__item-number--blue"
    }, "2."), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-list-etape__item-txt"
    }, "Nous discutons ensemble de vos besoins et objectifs")), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-list-etape__item"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "c-list-etape__item-number c-list-etape__item-number--dark-blue"
    }, "3."), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-list-etape__item-txt"
    }, "Nous trouvons pour vous le/a candidat/e qu\u2019il vous faut")), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-list-etape__item"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "c-list-etape__item-number c-list-etape__item-number--green"
    }, "4."), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-list-etape__item-txt"
    }, "Nous vous accompagnons tout au long du processus de recrutement")), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-list-etape__item"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "c-list-etape__item-number c-list-etape__item-number--orange"
    }, "5."), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-list-etape__item-txt"
    }, "Nous analysons les besoins d\u2019am\xE9nagements du poste et co-construisons les solutions d\u2019int\xE9gration avec vous")), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-list-etape__item"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "c-list-etape__item-number c-list-etape__item-number--pink"
    }, "6."), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-list-etape__item-txt"
    }, "Nous sensibilisons votre \xE9quipe et formons le r\xE9f\xE9rent du collaborateur dans le collectif de travail")), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-list-etape__item"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "c-list-etape__item-number c-list-etape__item-number--blue"
    }, "7."), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-list-etape__item-txt"
    }, "Vous \xEAtes accompagn\xE9s apr\xE8s le recrutement, pour s\u2019assurer que vos objectifs sont atteints"))), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-company-btn"
    }, /*#__PURE__*/_react.default.createElement(_Link.default, {
      className: "c-btn c-btn--orange",
      href: "/inscription-entreprise"
    }, "D\xE9posez votre offre"), /*#__PURE__*/_react.default.createElement(_Link.default, {
      className: "c-btn c-btn--blue",
      href: "/inscription-entreprise"
    }, "Contactez-nous")), /*#__PURE__*/_react.default.createElement("h2", {
      className: "c-title c-title--medium u-text-center u-margin-top-40  u-margin-bottom-0"
    }, "Les employeurs qui nous font d\xE9j\xE0 confiance"), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-partner"
    }, partners), /*#__PURE__*/_react.default.createElement(_BlockLastTestimonies.default, {
      type: "Entreprise"
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-aspie-map"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "c-aspie-map__column"
    }, /*#__PURE__*/_react.default.createElement(_Image.default, {
      src: "/images/cartefrance.svg"
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-aspie-map__column"
    }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h2", {
      className: "c-title c-title--medium u-margin-bottom-0"
    }, "Nous recrutons partout", /*#__PURE__*/_react.default.createElement("br", null), "en France"), /*#__PURE__*/_react.default.createElement("p", {
      className: "u-margin-top-0"
    }, "Nous couvrons tout le territoire national \xE0 partir", /*#__PURE__*/_react.default.createElement("br", null), "de nos 3 antennes :")), /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", {
      className: "c-circle-decoration c-circle-decoration--dark-blue"
    }, "\xCEle de France"), /*#__PURE__*/_react.default.createElement("li", {
      className: "c-circle-decoration c-circle-decoration--green"
    }, "Rh\xF4ne Alpes"), /*#__PURE__*/_react.default.createElement("li", {
      className: "c-circle-decoration c-circle-decoration--orange"
    }, "Nouvelle Aquitaine")), /*#__PURE__*/_react.default.createElement(_Link.default, {
      className: "c-btn c-btn--blue",
      href: "/inscription-entreprise"
    }, "Commencez avec nous"))), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-candidat-project u-margin-top-40"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "c-candidat-project__column"
    }, /*#__PURE__*/_react.default.createElement("h2", {
      className: "c-title c-title--medium"
    }, "Vous avez d\xE9j\xE0 recrut\xE9 un ", /*#__PURE__*/_react.default.createElement("br", null), "collaborateur et souhaitez ", /*#__PURE__*/_react.default.createElement("br", null), "des solutions d\u2019experts ?"), /*#__PURE__*/_react.default.createElement("p", {
      className: "text-big"
    }, "D\xE9posez votre offre ou pr\xE9sentez", /*#__PURE__*/_react.default.createElement("br", null), "nous de votre projet"), /*#__PURE__*/_react.default.createElement(_Link.default, {
      className: "c-btn c-btn--dark-blue u-margin-top-40",
      href: "/inscription-entreprise"
    }, "Inscrivez-vous gratuitement")), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-candidat-project__column"
    }, /*#__PURE__*/_react.default.createElement(_Image.default, {
      src: "/images/deposervotreoffre.svg",
      className: "c-candidat-project_img"
    }))), /*#__PURE__*/_react.default.createElement(_LoginModal.default, {
      onClose: component.closeLoginModal,
      open: state.login_modal,
      trigger_src: state.login_modal_trigger,
      onLogin: component.handleLogin
    })));
    return output;
  }
}
exports.default = InfoCompanyPage;
